module.exports = __webpack_public_path__ + "static/aso1-f0a93fdfcc2650905d8f5bd3331dc618.png";